var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.86 17.46-7-12a1 1 0 0 0-1.66 0l-7 12A1 1 0 0 0 5 19h14a1 1 0 0 0 .86-1.54ZM11 9.71h2v3.84h-2Zm1 7.57a1.21 1.21 0 1 1 0-2.42h.11a1.21 1.21 0 0 1 0 2.42Z",
    "data-name": "Layer 3"
  })));
};
export default SvgWarning;